/**
 * Shopify inbound presenter.
 */
import type { InboundProviderPresenter } from '@/lib/integrations/inbound/types'

import {
  SHOPIFY_EVENT_CATEGORIES,
  SHOPIFY_EVENT_METADATA,
} from './supported-events'

export const SHOPIFY_SIGNING_SECRET_MIN_LENGTH = 16

export const shopifyInboundPresenter: InboundProviderPresenter = {
  providerId: 'shopify',
  displayName: 'Shopify',
  categories: SHOPIFY_EVENT_CATEGORIES,
  events: SHOPIFY_EVENT_METADATA,
  eventSetupNote:
    'Shopify sends Brew an event only if that event has its own webhook. Create one for each event you plan to use, choosing the name shown after "In Shopify", then click Send test on it.',
  defaultTriggerLoop: true,
  triggerEventId({ orgId, brandId, eventType }) {
    return `shopify:${orgId}:${brandId}:${eventType}`
  },
}
